module.exports = __webpack_public_path__ + "4a1d8009368282ee6da97c81e354864f.MP3";